export default __webpack_public_path__ + "static/media/aboutUs-industry@2x.fb8be679.png";